import { Edit, Schema } from '@tunasong/icons'
import { condRenderComponent } from '@tunasong/plugin-lib'
import type { TunaPlugin } from '@tunasong/plugin-lib'
import { isRider } from '@tunasong/schemas'
import type { Rider } from '@tunasong/schemas'
import { syncRiderCommand } from './commands/sync.js'
import RiderContent from './content.js'
import RiderView from './views/default.js'
import RiderEditView from './views/edit.js'

const defaultTemplate: Rider = {
  type: 'rider',
  name: 'Technical Rider',
  members: [],
}

const plugin = (): TunaPlugin<Rider> => ({
  key: 'rider',
  node: {
    type: 'rider',
  },
  category: 'music',
  color: 'deepOrange',
  icon: Schema,
  description: 'Technical Rider',
  templates: [{ template: defaultTemplate, name: 'Technical Rider' }],
  components: {
    Content: condRenderComponent(isRider, RiderContent),
  },
  getEntityCommands: context => {
    if (!isRider(context.entity)) {
      return []
    }
    return syncRiderCommand(context)
  },
  layouts: [
    { name: 'Rider', Icon: Schema, Component: RiderView, container: {} },
    { name: 'Edit', Icon: Edit, Component: RiderEditView, container: {} },
  ],
})

export default plugin

export { generateRiderFromProfiles } from './generate.js'
export { syncRiderFromProfiles } from './sync.js'
